import { Location } from '@shared/types'
import { apiJSON } from '@shared/utils/api/api.util'
import { useQuery } from 'react-query'

export function useCompanyQuery(companyID: number) {
  const { data: company } = useQuery<Location>(`companies/${companyID}`, () =>
    apiJSON(`companies/${companyID}`)
  )

  return { company }
}
